namespace Controlli {
    export namespace Modal {
        let _object;
        let _titolo;
        let _container;
        let _corpo;

        export function Initialize() {
            _object = $("[data-modalobj-object]");
            _titolo = $("[data-modalobj-titolo]");
            _container = $("[data-modalobj-container]");
            _corpo = $("[data-modalobj-corpo]");

            bootstrap.Modal.Default.backdrop = true;
            bootstrap.Modal.Default.focus = true;
            bootstrap.Modal.Default.keyboard = true;
        }

        export function Show() {
            _object.modal("show");
        }
        export function Hide() {
            _object.modal("hide");
        }
        export function Load(_options: ModalOptions) {
            _titolo.html(_options.Titolo);
            Ajax.AjaxLoadingHTML(_options.Url, "[data-modalobj-corpo]", _options.UrlData);
            SetDimension(_options.Dimensione.toString().toLowerCase());
            Show();
        }

        export function SetDimension(_dimensione: string) {
            _container.removeClass("modal-sm");
            _container.removeClass("modal-lg");
            _container.removeClass("modal-xl");
            _container.removeClass("modal-fullscreen");

            switch (ModalDimensions[_dimensione]) {
                case ModalDimensions.small:
                    _container.addClass("modal-sm");
                    break;
                case ModalDimensions.large:
                    _container.addClass("modal-lg");
                    break;
                case ModalDimensions.extralarge:
                    _container.addClass("modal-xl");
                    break;
                case ModalDimensions.fullscreen:
                    _container.addClass("modal-fullscreen");
                    break;
                default:
                    _container.addClass("modal-lg");
                    break;
            }
        }

        //Return from controller
        export function AjaxFormModalOnBegin() { /* document why this function 'AjaxFormModalOnBegin' is empty */  }
        export function AjaxFormModalOnComplete(result) {
            let _data: Ajax.FormJsonResult = result.responseJSON;

            switch (_data.Stato) {
                case Ajax.StatoForm.OK:
                    _corpo.html(_data.PartialView);
                    Utility.RefreshControl(_corpo);
                    Hide();

                    break;
                case Ajax.StatoForm.OK_Apri:
                case Ajax.StatoForm.Errore_Model:
                case Ajax.StatoForm.Errore:
                    _corpo.html(_data.PartialView);
                    Utility.RefreshControl(_corpo);
                    break;
                case Ajax.StatoForm.OK_Redirect:
                    Hide();
                    Ajax.AjaxRedirectToAction(_data.Url);
                    break;
                case Ajax.StatoForm.OK_RefreshBody:
                    Hide();
                    Ajax.AjaxLoadingHTML(_data.Url);
                    break;
                case Ajax.StatoForm.OK_RefreshTarget:
                    Hide();
                    Ajax.AjaxLoadingHTML(_data.Url, _data.TargetID);
                    break;
                case Ajax.StatoForm.Undefined:
                    break;
            }
        }
        export function AjaxFormModalOnSuccess() { /* document why this function 'AjaxFormModalOnSuccess' is empty */  }
        export function AjaxFormModalOnFailure() { /* document why this function 'AjaxFormModalOnFailure' is empty */  }

        export class ModalOptions {
            Url: string;
            UrlData: object;
            Titolo: string;
            Dimensione: ModalDimensions;

            constructor() {
                this.Titolo = "Titolo View";
                this.Dimensione = ModalDimensions.default;
            }
        }
        export enum ModalDimensions {
            default,
            small,
            large,
            extralarge,
            fullscreen
        }
    }
}